import { Currency, IAccount, Locale } from "@lib";

export function getTableColumns(context: any): any[] {
    return [
        {
            colId: "actions",
            headerName: "Изменить/удалить",
            width: 90,
            hide: !context.can.update && !context.can.delete,
            headerClass: "text-transparent",

            cellRendererFramework: "CellRendererActions",
            cellRendererParams: (params: any) => {
                return {
                    actions: [
                        {
                            id: "edit",
                            description: "Изменить",
                            icon: "Edit3Icon",
                            classes: "h-1 w-1 mr-0.75 hover:text-primary cursor-pointer",
                            isVisible: () => context.can.update,
                            click: (account: IAccount) => context.openModalUpdate(account),
                        },
                        {
                            id: "delete",
                            description: "Удалить",
                            icon: "Trash2Icon",
                            classes: "h-1 w-1 mr-0.75 hover:text-danger cursor-pointer",
                            isVisible: () => context.can.delete,
                            click: (account: IAccount) => context.confirmDelete(account),
                        },
                    ],
                };
            },
        },
        {
            colId: "number",
            field: "number",
            headerName: "#",
            sortable: true,
            filter: true,
            width: 70,
            hide: false,
        },
        {
            colId: "name",
            field: "info.name",
            headerName: "Наименование",
            sortable: true,
            filter: true,
            width: 250,
            hide: false,
        },
        {
            colId: "balance",
            field: "balance",
            headerName: "Баланс",
            sortable: true,
            filter: true,
            width: 130,
            hide: false,
            cellRendererFramework: "CellRendererMoney",
            cellRendererParams: (params: any) => {
                const account = params.data as IAccount;
                return {
                    locale: account?.info.locale ?? Locale.RU,
                    currency: account?.info.currency ?? Currency.RUB,
                };
            },
        },
        {
            colId: "description",
            field: "info.description",
            headerName: "Описание",
            sortable: true,
            filter: true,
            width: 400,
            hide: false,
        },
    ];
}
